<template>
  <div class="container-fluid">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <b-button variant="primary" v-auth="`update`" @click="outputBill()">產生帳單</b-button>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import billApi from "@/models/API/billApi";

export default {
  name: 'billingSettings',
  components: {
    BreadCrumb,
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '設定', url: '', isActive: true },
          { name: '帳單設定', url: '', isActive: false }
        ]
      }
    }
  },
  mounted() {
    this.billApi = new billApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {

    },
    // 產生帳單(每個月一次，手動出帳單)
    outputBill() {
      const r = confirm("確定產生帳單？");

      if (r) {
        this.billApi.outputBill((response) => {
          const res = response.data;
          let result = {};

          if (res.code === 0) {
            result = { message: `產生帳單成功`, title: '帳單' };
          } else if (res.code === 1) {
            result = { message: `重複產生帳單`, title: '帳單' };
          }

          this.billApi.toast(() => {}, result, res.code === 0);
        })

        return true;
      }
      return false;
    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/billingSettings.vue